import api from "../api";
import { AppContext } from "../quote/types";

class AppApi {
    private baseUrl = "/app";

    getAppContext = async (): Promise<AppContext> => {
        const { data } = await api.get(this.baseUrl + "/context");
        return data;
    };
}
export default new AppApi();